

export enum SettingsSection {

    COMPANY_ALL     = 'organization-all',
    TASKS_PROJECTS  = 'tasks-projects',
    PRODUCTIVITY    = 'productivity-collaboration',
    AUTOMATIONS     = 'automations-all',
    USERS           = 'company-users',
    ACCESS          = 'access-permissions',
    TIME_RESOURCES  = 'time-resources',
    CLOCK_IN_OUT    = 'clock-in-out',
    BILLING         = 'billing-finance',
    CRM             = 'crm',
    VIEWS           = 'views',
    SYSTEM          = 'system',
    ACCOUNT         = 'organization-accounts',
}

export const SettingsSectionTitleDict : any = {

    [SettingsSection.COMPANY_ALL]       : 'All Settings',
    [SettingsSection.TASKS_PROJECTS]    : 'Tasks & Projects',
    [SettingsSection.PRODUCTIVITY]      : 'Productivity & Collaboration',
    [SettingsSection.AUTOMATIONS]       : 'Automations',
    [SettingsSection.USERS]             : 'Human Resources (HR)',
    [SettingsSection.ACCESS]            : 'Access & Permissions',
    [SettingsSection.TIME_RESOURCES]    : 'Time and Resources',
    [SettingsSection.CLOCK_IN_OUT]      : 'Clock-in/Clock Out',
    [SettingsSection.BILLING]           : 'Billing & Finance',
    [SettingsSection.CRM]               : 'CRM',
    [SettingsSection.VIEWS]             : 'Views',
    [SettingsSection.SYSTEM]            : 'System',
    [SettingsSection.ACCOUNT]           : 'Organization account',

}

